import React from 'react';
import Divider from '@material-ui/core/Divider';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';

const RequestPreview = ({ label, keyword, reservationRequest, Details, Chips }) => {

    return (
        <>
            <div className="panel-content-wrapper">
                <Typography variant="h6" gutterBottom>
                    {label} in Details
                </Typography>

                <div className="panel-content-info-wrapper">
                    <Chip
                        size="medium"
                        label={`${reservationRequest.category} ${label}`}
                        variant="default"
                        color="default"
                    />
                    <Typography variant="body2" gutterBottom className="panel-content-info-date">
                        Created {reservationRequest.createDate.substring(0, 10)}
                    </Typography>
                </div>
                {Details}
            </div>
            {
                Chips ?
                    <>
                        <Divider />
                        <div className="panel-keyword-container">
                            <Typography variant="subtitle2" gutterBottom>
                                {keyword}
                            </Typography>
                            {Chips}
                        </div>
                    </>
                    : null
            }
        </>
    );
}

export default RequestPreview;